export default "__VITE_ASSET__6NMve9eI__"